import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { EstimativaCronograma } from '../models/estimativa-cronograma.model';

@Injectable({
    providedIn: 'root'
})

export class EstimativaCronogramaService extends BaseService<EstimativaCronograma> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/EstimativaCronograma`, injector);
    }

    getByEstimativaId(estimativaId: number): Observable<EstimativaCronograma> {
        return this.http.get<EstimativaCronograma>(`${this.apiPath}/GetByEstimativaId/${estimativaId}`);
    }

    gerarCronogramaComIA(estimativaId: number, tipoCronograma: string): Observable<EstimativaCronograma> {
        return this.http.get<EstimativaCronograma>(`${this.apiPath}/GerarCronograma/${estimativaId}/${tipoCronograma}`);
    }

    estimativaAlterouDados(estimativaId: number): Observable<boolean> {
        return this.http.get<boolean>(`${this.apiPath}/EstimativaAlterouDados/${estimativaId}`);
    }
}